export enum DeliveryPolicyType {
    Electronic = 'electronic',
    Email = 'email',
    Mail = 'mail'
}

export type BillingTemplatesListModel = {
    billingTemplateId: string,
    templateName: string,
    organizationId: string,
    organizationName: string,
    businessId: string,
    isDefault: boolean
}

export type Address = {
    street: string,
    city: string,
    zip: string,
    countryCode: string
}

export type ContactData = {
    contactPersonName: string | null,
    contactPersonEmail: string | null
}

export type BasicBillingTemplate = {
    organizationId: string,
    templateName: string,
    organizationName: string,
    businessId: string,
    vatId: string,
    customerNumber: string,
    reference: string,
    paymentTerms: number | null,
    invoiceDescription?: string | null
} & ContactData & Address

export type ElectronicDeliveryPolicy = {
    electronicAddress: string
    electronicOperatorId: string,
    electronicOperatorCode: string
}

export type EmailDeliveryPolicy = {
    email: string
}

export type DeliveryPolicy = { deliveryPolicyType: DeliveryPolicyType } & ElectronicDeliveryPolicy & EmailDeliveryPolicy

export type AddBasicBillingTemplate = BasicBillingTemplate

export type AddEmailBillingTemplate = BasicBillingTemplate & EmailDeliveryPolicy

export type AddElectronicBillingTemplate = BasicBillingTemplate & ElectronicDeliveryPolicy

export type GetBillingTemplate = BasicBillingTemplate & {
    billingTemplateId: string,
    isDefault: boolean,
    deliveryPolicyType: DeliveryPolicyType,
    deliveryPolicy: ElectronicDeliveryPolicy & EmailDeliveryPolicy
}

export type BillingTemplateIdentifier = {
    billingTemplateId: string,
    organizationId: string
}

export type ChangeBillingTemplateName = BillingTemplateIdentifier & {
    templateName: string
}

export type ChangeOrganizationName = BillingTemplateIdentifier & {
    organizationName: string
}

export type ChangeBusinessId = BillingTemplateIdentifier & {
    businessId: string
}

export type ChangeVatId = BillingTemplateIdentifier & {
    vatId: string
}

export type ChangeCustomerNumber = BillingTemplateIdentifier & {
    customerNumber: string
}

export type ChangePaymentTerms = BillingTemplateIdentifier & {
    paymentTerms: number | null
}

export type ChangeReference = BillingTemplateIdentifier & {
    reference: string
}

export type ChangeInvoiceDescription = BillingTemplateIdentifier & {
    invoiceDescription: string | null
}

export type ChangeContactData = BillingTemplateIdentifier & ContactData

export type ChangeAddress = BillingTemplateIdentifier & Address

export type AssignElectronicDeliveryPolicy = BillingTemplateIdentifier & ElectronicDeliveryPolicy

export type AssignEmailDeliveryPolicy = BillingTemplateIdentifier & EmailDeliveryPolicy

export type AssignMailDeliveryPolicy = BillingTemplateIdentifier

export type MarkDefaultBillingTemplate = BillingTemplateIdentifier
